import { MenuItem } from '@chronosphereio/chrono-ui';
import { useRef } from 'react';
import { DASHBOARD_TOOLTIP_TEXT } from '../../constants';
import { useDashboard, useDashboardMetadata } from '../../context';

export function DownloadMenuItem() {
  const { dashboard } = useDashboard();
  const { metadata } = useDashboardMetadata();
  const hiddenLinkRef = useRef<HTMLAnchorElement>(null);

  const onClick = () => {
    if (!hiddenLinkRef || !hiddenLinkRef.current) return;
    // Create blob URL
    const hiddenLinkUrl = URL.createObjectURL(
      new Blob([JSON.stringify(dashboard, null, 2)], {
        type: 'application/json',
      })
    );
    // Simulate click
    hiddenLinkRef.current.href = hiddenLinkUrl;
    hiddenLinkRef.current.click();
    // Remove blob URL (for memory management)
    URL.revokeObjectURL(hiddenLinkUrl);
  };

  return (
    <>
      <MenuItem onClick={onClick}>{DASHBOARD_TOOLTIP_TEXT.downloadDashboard}</MenuItem>
      {/* Hidden link to download the dashboard as a JSON file */}
      {/* eslint-disable jsx-a11y/anchor-has-content */}
      {/* eslint-disable jsx-a11y/anchor-is-valid  */}
      <a ref={hiddenLinkRef} style={{ display: 'none' }} download={`${metadata.name}.json`} />
    </>
  );
}
